import { useEffect, useState } from "react";
import client from "@/lib/api";
import { ImageOff } from "lucide-react";

// Authenticated photo from file storage.
export function FilePhoto({ id, className = "h-24 w-24" }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let u;
    client.get(`/files/${id}/download`, { responseType: "blob" }).then((r) => {
      u = URL.createObjectURL(r.data); setUrl(u);
    }).catch(() => setFailed(true));
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [id]);
  if (failed) return <div className={`${className} rounded bg-slate-50 border border-slate-200 flex flex-col items-center justify-center text-[10px] text-slate-400`}><ImageOff className="h-4 w-4 mb-1" />Photo unavailable</div>;
  if (!url) return <div className={`${className} rounded bg-slate-100 animate-pulse`} />;
  return (
    <a href={url} target="_blank" rel="noreferrer" data-testid={`file-photo-${id}`}>
      <img src={url} alt="job" className={`${className} rounded object-cover border border-slate-200`} />
    </a>
  );
}
